'use client';
import ResetPasswordCard from '@/components/ResetPassword/ResetPasswordCard';

const ResetPassword = () => {
  return (
    <div className={'card card-3-light my-3'}>
      <div className="card-title pt-3">
        <h2 className="text-center">Réinitialiser le mot de passe</h2>
      </div>
      <ResetPasswordCard />
    </div>
  );
};

export default ResetPassword;
